import gql from "graphql-tag";
import {
    ScheduledCgoNodeFragment,
    ScheduledFlightFragment,
    ScheduledPaxNodeFragment
} from "../../../../../Queries/Scheduling";

export const GetFlightQuery = gql`
    mutation PurgeEntitiesFromFlightTool_GetFlight($flightID: ID!){
        getFlight(flightID: $flightID){
            ...ScheduledFlightFragment
        }
    }
    ${ScheduledFlightFragment}
`

export const RemovePaxCgoFromFlightMutation = gql`
mutation PurgeEntitiesFromFlightTool_RemovePaxCgoFromFlight($flightID: ID!, $paxIDs: [ID!]!, $cgoIDs: [ID!]!){
    removePaxCgoFromFlight(flightID: $flightID, paxIDs: $paxIDs, cgoIDs: $cgoIDs){
        flight {
            ...ScheduledFlightFragment
        }
        paxNodes {
            ...ScheduledPaxNodeFragment
        }
        cgoNodes {
            ...ScheduledCgoNodeFragment
        }
    }
}
${ScheduledFlightFragment}
${ScheduledPaxNodeFragment}
${ScheduledCgoNodeFragment}
`